module.exports = __webpack_public_path__ + "static/img/win_prize.3e6951b.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/daily/win_prize.png
// module id = 553
// module chunks = 1